import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import AttachFile from '@mui/icons-material/AttachFile';
import EmojiEmotions from '@mui/icons-material/EmojiEmotions';
import FormatBold from '@mui/icons-material/FormatBold';
import FormatItalic from '@mui/icons-material/FormatItalic';
import FormatQuote from '@mui/icons-material/FormatQuote';
import Link from '@mui/icons-material/Link';

import map from 'lodash/map';

import { Button } from 'uikit/buttons';
import { EmojiButton } from 'uikit/reactions';

import QuillUploadButton from './quillUploadButton';
import getQuillToolbarFormats from '../helpers/getQuillToolbarFormats';

import styles from '../styles/quillToolbar.module.scss';

const TOOLBAR_ICON_MAPPINGS = {
  bold: FormatBold,
  italic: FormatItalic,
  blockquote: FormatQuote,
  link: Link,
  file: AttachFile,
  emoji: EmojiEmotions,
};

const QuillToolbar = React.forwardRef(({
  className, onEmojiSelect, onFileUploadClick, fileUploadAriaLabel,
}, ref) => (
  <div
    id="quill-toolbar"
    className={classnames(styles.element, className)}
    ref={ref}
  >
    {map(getQuillToolbarFormats(), (toolbarFormat) => {
      if (toolbarFormat === 'emoji') {
        return (
          <EmojiButton
            key={`quill-toolbar__button-${toolbarFormat}`}
            onSelect={onEmojiSelect}
            emojiPickerPosition="bottomRight"
          />
        );
      }

      if (toolbarFormat === 'file') {
        return (
          <QuillUploadButton
            fileUploadAriaLabel={fileUploadAriaLabel}
            onClick={onFileUploadClick}
            key={`quill-toolbar__button-${toolbarFormat}`}
          />
        );
      }

      const Icon = TOOLBAR_ICON_MAPPINGS[toolbarFormat];

      return (
        <Button
          ariaLabel={toolbarFormat}
          className={`ql-${toolbarFormat}`}
          key={`quill-toolbar__button-${toolbarFormat}`}
          variant="ghost"
        >
          <Icon />
        </Button>
      );
    })}
  </div>
));

QuillToolbar.defaultProps = {
  className: '',
  fileUploadAriaLabel: '',
  onEmojiSelect: () => {},
  onFileUploadClick: () => {},
};

QuillToolbar.propTypes = {
  className: PropTypes.string,
  fileUploadAriaLabel: PropTypes.string,
  onEmojiSelect: PropTypes.func,
  onFileUploadClick: PropTypes.func,
};

export default React.memo(QuillToolbar);
